import { Icon } from 'react-bootstrap-icons';

import './CircleSpinnerIcon.scss';

export const CircleSpinnerIcon: Icon = ({
  color = 'currentColor',
  size = '1em',
  title = null,
  ...rest
}) => {
  return (
    <svg
      { ...rest }
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 600 600"
      width={ size }
      height={ size }
      preserveAspectRatio="xMidYMid meet"
    >
      { title ? <title>{ title }</title> : null }

      <g style={{ transform: 'scale(1.325)', transformOrigin: 'center' }}>
        <g transform="matrix(-0.8660253882408142,0.5,-0.5,-0.8660253882408142,300,300)" opacity="0.88" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.0833s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(-0.5,0.8660253882408142,-0.8660253882408142,-0.5,300,300)" opacity="0.8" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.167s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0,1,-1,0,300,300)" opacity="0.72" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.2497s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0.5,0.8660253882408142,-0.8660253882408142,0.5,300,300)" opacity="0.64" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.333s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0.8660253882408142,0.5,-0.5,0.8660253882408142,300,300)" opacity="0.56" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.4167s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(1,0,0,1,300,300)" opacity="0.48" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.5s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0.8660253882408142,-0.5,0.5,0.8660253882408142,300,300)" opacity="0.4" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.5837s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0.5,-0.8660253882408142,0.8660253882408142,0.5,300,300)" opacity="0.32" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.667s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(0,-1,1,0,300,300)" opacity="0.24" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.7497s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(-0.5,-0.8660253882408142,0.8660253882408142,-0.5,300,300)" opacity="0.16" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.833s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(-0.8660253882408142,-0.5,0.5,-0.8660253882408142,300,300)" opacity="0.08" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '-0.9167s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
        <g transform="matrix(-1,0,0,-1,300,300)" opacity="1" style={{ animation: 'circle-spinner-fade 1s linear infinite', animationDelay: '0s' }}>
          <g opacity="1" transform="matrix(1,0,0,1,-11,82)">
            <path strokeLinecap="round" strokeLinejoin="miter" fillOpacity="0" strokeMiterlimit="4" stroke={ color } strokeOpacity="1" strokeWidth="40" d=" M13,22 C13,22 13,124 13,124"></path>
          </g>
        </g>
      </g>
    </svg>
    // <div className="ios-spinner" style={{ width: size, height: size }} title={ title || undefined }>
    //   <div style={{ background: color }} className="ios-spinner-bar1"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar2"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar3"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar4"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar5"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar6"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar7"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar8"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar9"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar10"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar11"></div>
    //   <div style={{ background: color }} className="ios-spinner-bar12"></div>
    // </div>
  );
};
